import type { SampledVector } from './hermite';

interface EphemerisResponse {
  target: string;
  center: string;
  frame: string;
  units: { length: string; time: string };
  points: SampledVector[];
  source: string;
  api_version: string;
  cached: boolean;
  note: string | null;
}

/** JD ↔ ISO helpers (proleptic Gregorian, UT). */
export function jdToIso(jd: number): string {
  const ms = (jd - 2440587.5) * 86400 * 1000;
  return new Date(ms).toISOString().slice(0, 10);
}

export function isoToJd(iso: string): number {
  const ms = Date.parse(iso + 'T00:00:00Z');
  return ms / 86400 / 1000 + 2440587.5;
}

export async function fetchVectors(
  target: string,
  start: string,
  stop: string,
  step = '1d',
  center = '@sun',
): Promise<EphemerisResponse> {
  const url = new URL('/api/ephemeris/vector', window.location.origin);
  url.searchParams.set('target', target);
  url.searchParams.set('start', start);
  url.searchParams.set('stop', stop);
  url.searchParams.set('step', step);
  url.searchParams.set('center', center);
  const r = await fetch(url.toString());
  if (!r.ok) {
    const txt = await r.text();
    throw new Error(`ephemeris/${target} HTTP ${r.status}: ${txt.slice(0, 200)}`);
  }
  return r.json() as Promise<EphemerisResponse>;
}

/** Lance N requêtes en parallèle. Échec sur une cible n'échoue pas toutes. */
export async function fetchManyVectors(
  targets: string[],
  start: string,
  stop: string,
  step = '1d',
): Promise<Record<string, SampledVector[]>> {
  const results = await Promise.allSettled(
    targets.map((t) => fetchVectors(t, start, stop, step)),
  );
  const out: Record<string, SampledVector[]> = {};
  results.forEach((r, i) => {
    if (r.status === 'fulfilled') {
      out[targets[i]] = r.value.points;
    } else {
      console.warn(`[ephemeris] ${targets[i]} failed:`, r.reason);
    }
  });
  return out;
}
